import { updateAsset } from '@ps/bridge/qc/node'
import store from '@ps/store'
import _ from 'lodash'
import nodePool from '@ps/bridge/qc/node-pool'
import { setStyle } from '@ps/store/workbench/common/node-utils'
import { isDragonBoneChild } from '@ps/utils/game'
import { EventBus, Event } from '@ps/utils/event-bus'

export type SetImageActionValue = {
  newValue: {
    resourceUuid: string
    nodeUuid: string
    resetImageAfterAdd: true
    addImageToConfig: boolean
  }[]
  oldValue: {
    resourceUuid: string
    nodeUuid: string
    resetImageAfterAdd: true
    addImageToConfig: boolean
    // undo 的时候需要记录宽高，保证 undo 回去是正确的宽高
    style: {
      width?: number
      height?: number
    }
    phaserTexture: unknown
  }[]
}

export function getSetImageAction(value: SetImageActionValue) {
  return {
    execute: async ({ newValue }: SetImageActionValue) => {
      const taskList = newValue.map(async (value) => {
        const { resourceUuid, nodeUuid, resetImageAfterAdd, addImageToConfig } =
          value
        await updateAsset({ resourceUuid, nodeUuid })
        const node = nodePool.find(nodeUuid)
        const img = _.get(node, 'texture.atlas.img')
        const currentSrc =
          img &&
          typeof img.getAttribute === 'function' &&
          img.getAttribute('src')
            ? img.getAttribute('src')
            : ''
        if (addImageToConfig) {
          // 上传图片，功滤镜处理模块使用
          await store.dispatch(
            'workspace/editorConfig/updateTargetNodeConfig',
            {
              originalResource: currentSrc,
              resource: currentSrc,
              node: node,
            },
          )
        }
        if (resetImageAfterAdd) {
          await store.dispatch('workspace/game/resetNativeSize', {
            node: node,
            record: false,
          })
        }
      })
      await Promise.all(taskList)
      EventBus.$emit(Event.RESOURCE_POOL_REFRESH)
    },
    undo: async ({ oldValue }: SetImageActionValue) => {
      const taskList = oldValue.map(async (value) => {
        const {
          resourceUuid,
          nodeUuid,
          resetImageAfterAdd,
          style,
          phaserTexture,
          addImageToConfig,
        } = value
        const node = nodePool.find(nodeUuid)
        if (!resourceUuid && isDragonBoneChild(node)) {
          // @ts-ignore
          node.texture = null
          // @ts-ignore
          node.phaser.texture = phaserTexture
        } else {
          await updateAsset({ resourceUuid, nodeUuid })
        }
        if (addImageToConfig) {
          const img = _.get(node, 'texture.atlas.img')
          const currentSrc =
            img &&
            typeof img.getAttribute === 'function' &&
            img.getAttribute('src')
              ? img.getAttribute('src')
              : ''
          // 上传图片，功滤镜处理模块使用
          await store.dispatch(
            'workspace/editorConfig/updateTargetNodeConfig',
            {
              originalResource: currentSrc,
              resource: currentSrc,
              node: node,
            },
          )
        }
        if (_.isNumber(style.width) && _.isNumber(style.height)) {
          setStyle(node, style)
        } else if (resetImageAfterAdd) {
          await store.dispatch('workspace/game/resetNativeSize', {
            node: node,
            record: false,
          })
        }
      })
      await Promise.all(taskList)
      EventBus.$emit(Event.RESOURCE_POOL_REFRESH)
    },
    value,
    async: true,
    methodName: 'getSetImageAction',
  }
}
